import { toRem } from "../../../helpers/theme";

const Style = ({ theme }) => ({
    position: "relative",
    paddingLeft: toRem(30),
    paddingRight: toRem(30),
    [theme.breakpoints.up("md")]: {
        paddingLeft: toRem(60),
        paddingRight: toRem(60),
    },
    "& .dishDrawerInput": {
        [theme.breakpoints.up("md")]: {
            marginBottom: toRem(20),
        },
    },
    "& .dishDrawerListing": {
        paddingTop: toRem(20),
    },
});

export default Style;
